import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create(() => ({
  signInPrompt: {
    flexDirection: 'row',
    gap: theme.spacing[1],
    alignItems: 'center',
  },
}));
